module.exports = __webpack_public_path__ + "img/floor_OG4.62417f27.svg";